export default __webpack_public_path__ + "static/media/loruki.e05baa3b.JPG";